import { Link } from 'react-router-dom';

export default function TrainingDirections() {
  const directions = [
    {
      icon: 'ri-presentation-line',
      title: 'Корпоративные тренинги',
      desc: 'Системное обучение сотрудников: от диагностики до внедрения. Программы адаптируются под бизнес-задачи компании.',
      to: '/enciklopediya-korporativnogo-obucheniya/chto-takoe-korporativnoe-obuchenie'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Продажи',
      desc: 'Рост конверсии, работа с возражениями, скрипты продаж. От холодного звонка до закрытия крупной сделки.',
      to: '/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh'
    },
    {
      icon: 'ri-shake-hands-line',
      title: 'Переговоры',
      desc: 'Стратегии переговоров, работа с ЛПР, защита цены, выход на win-win. Для B2B и сложных сделок.',
      to: '/prodazhi-i-peregovory/trening-po-peregovoram'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Руководители',
      desc: 'Управление командой, наставничество, мотивация, контроль. От специалиста к эффективному управленцу.',
      to: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley'
    },
    {
      icon: 'ri-chat-smile-3-line',
      title: 'Soft Skills',
      desc: 'Коммуникации, эмоциональный интеллект, стресс-менеджмент. Навыки, которые определяют эффективность.',
      to: '/enciklopediya-korporativnogo-obucheniya/razvitie-soft-skills'
    },
    {
      icon: 'ri-group-line',
      title: 'Командообразование',
      desc: 'Тимбилдинги, бизнес-игры, развитие командного взаимодействия. Сплочение и рост доверия.',
      to: '/enciklopediya-korporativnogo-obucheniya/komandoobrazovanie'
    },
    {
      icon: 'ri-building-line',
      title: 'Корпоративная академия',
      desc: 'Построение системы обучения внутри компании. От идеи до работающей образовательной экосистемы.',
      to: '/enciklopediya-korporativnogo-obucheniya/korporativnaya-akademiya'
    }
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Направления обучения
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Каждое направление — это отдельная экспертиза. Выберите то, что актуально для вашей компании прямо сейчас.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {directions.map((dir, i) => (
            <Link
              key={i}
              to={dir.to}
              className="bg-white rounded-xl p-6 md:p-7 hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 group cursor-pointer"
            >
              <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-teal-600 transition-colors duration-300">
                <i className={`${dir.icon} text-xl text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                {dir.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">{dir.desc}</p>
              <div className="mt-4 flex items-center gap-1 text-teal-600 font-semibold text-sm group-hover:gap-2 transition-all">
                <span>Подробнее</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}